import { render, staticRenderFns } from "./ResultConfigurationSection.vue?vue&type=template&id=c8b6a326&scoped=true"
import script from "./ResultConfigurationSection.vue?vue&type=script&lang=js"
export * from "./ResultConfigurationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b6a326",
  null
  
)

export default component.exports